import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

const styles = makeStyles(() => ({
  instructions: {
    color: '#000',
  },
}));

export default function EssayInstructions({ version }) {
  const classes = styles();

  return (
    <Box>
      <label className={classes.instructions}>Type a 2000-word essay using the following guidelines.</label>
      <br />
      {version === 2 && (
        <>
          <Box sx={{ width: '95%', marginBottom: 10, marginTop: 10 }}>
            <section>
              Your essay should reflect your authentic voice, your ideas tone and experiences. You may use tools like AI for editing, grammar, or
              structure assistance, but the thoughts, stories, and insights must come from you. If you use AI, include a short note at the end (1-2
              sentences) explaining how you used AI in your writing process, if at all. Please note that all essays will be checked for AI use, if not
              used appropriately, it might cause the application to be returned.
            </section>
          </Box>
        </>
      )}
      <label className={classes.instructions}>The essay should have four parts:</label>
      <label className={classes.instructions}>
        {version === 2 ? (
          <>
            <ol>
              <li>
                <Box mt={1}>
                  <strong>Introduction</strong>
                </Box>
              </li>
              <section>
                Begin by introducing yourself and sharing a brief overview of your plans following graduation. This can include your educational or
                career goals.
              </section>
              <li>
                <Box mt={1}>
                  <strong>Reflection on Your Boys Town Experience</strong>
                </Box>
              </li>
              <section>
                Reflect on your time at Boys Town by choosing at least one of the following questions to answer:
                <ul style={{ listStyleType: 'disc', color: '#000', listStylePosition: 'inside' }}>
                  <li style={{ color: 'inherit' }}>What is the most valuable lesson you have learned during your time here?</li>
                  <li style={{ color: 'inherit' }}>Who has played a key role in helping you understand what it takes to be successful?</li>
                </ul>
              </section>
              <li>
                <Box mt={1}>
                  <strong>Looking Ahead: Challenges and Growth</strong>
                </Box>
              </li>
              <section>
                Describe the challenges you anticipate facing in the future. How will the lessons you have learned at Boys Town help you overcome
                these obstacles?
              </section>
              <li>
                <Box my={1}>
                  <strong>Conclusion: Preparation and Gratitude</strong>
                </Box>
              </li>
              <section>
                Conclude your essay by describing the steps you’ve taken to prepare for your future after Boys Town—both personally and in terms of
                school or employment. Express your gratitude for the opportunity to apply, share what success means to you, and explain how the
                support you've received at Boys Town will continue to guide you in your future endeavors.
              </section>
            </ol>
          </>
        ) : (
          <ol>
            <li>
              Start by introducing yourself and briefly describe your post-graduation plans. You could use a summarized version of what you already
              wrote as part of the application above.
            </li>
            <li>
              Reflect on your experiences at Boys Town, answering questions such as: What is your greatest lesson(s) learned at Boys Town? Who has
              been instrumental in teaching you how to be successful?
            </li>
            <li>
              Explain the needs you have in order to achieve the plan from the introductory paragraph and address questions such as: What do you
              anticipate your future temptations/struggles will be? How will you use what you have learned to overcome obstacles in order to be
              successful? How are you stronger today than you were before?
            </li>
            <li>
              Finally, close your essay communicating what you have done to prepare for your future (both personally, as well as with school and
              employment) after you depart/ed Boys Town. Express thanks for the opportunity to apply, describe what success means to you, and how the
              Boys Town support will help you be successful in your future life.
            </li>
          </ol>
        )}
      </label>
    </Box>
  );
}
